import * as React from 'react'
import { useState } from 'react'
import Popup from 'reactjs-popup'
import PickingList from '../files/PickingList'
import { JobNumberShape } from '../../api/api_data_types'
import useFetchOrderStatus from '../../hooks/useFetchOrderStatus'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'
import EditStatusButton from '../job_plannings/EditStatusButton'

type PickingListPopupButtonProps = {
  jobnumber: JobNumberShape
  currentUser: { username: string }
  className?: string
}

export default function PickingListPopupButton({ jobnumber, currentUser, className }: PickingListPopupButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => {
    setIsOpen(false)
  }
  const disabled = !jobnumber || !jobnumber.job_id
  const { isLoading, data, error, isError, statusCode, setStatusCode } = useFetchOrderStatus(jobnumber)
  const title = jobnumber ? `Plukliste - ${jobnumber.full_title}` : 'Plukliste'

  return (
    <>
      <button type="button" className={className} onClick={() => setIsOpen(true)} disabled={disabled}>
        Plukliste
      </button>

      <Popup
        open={isOpen}
        onClose={handleClose}
        position="center center"
        contentStyle={{ width: 'auto', maxWidth: '100%', zIndex: 2000 }}
        overlayStyle={{ zIndex: 1999 }}
        modal
        nested
      >
        <div className="modal-popup">
          <a className="close" onClick={handleClose}>
            &times;
          </a>
          <div className="popup-header">
            <h6 className="modal-title">{title}</h6>
          </div>
          <div className="popup-content flex-grow-1 overflow-auto">
            <div className="mb-2">
              <span>Status:</span>
              {isLoading && <i className="fa fa-spinner fa-spin" />}
              <ErrorMessage className="d-inline error-message" error={error} isError={isError} />
              {jobnumber && data && <EditStatusButton jobId={jobnumber.job_id} statusCode={statusCode} setStatusCode={setStatusCode} />}
            </div>
            <PickingList jobnumber={jobnumber} currentUser={currentUser} />
          </div>
        </div>
      </Popup>
    </>
  )
}
